<template>
    <el-select
        v-model="innerValue"
        @change="langChange"
        class="select-wrapper"
        :placeholder="placeholder"
        :filterable="!!filterable"
        :disabled="disabled"
        :multiple="!!multiple"
    >
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label ? item.label : $t(item.i18nKey)"
            :value="item.value"
            :disabled="item.disabled"
        ></el-option>
    </el-select>
</template>

<script>
export default {
    name: "Select",
    props: ["value", "options", "multiple", "filterable", "placeholder", "disabled"],
    model: {
        props: "value",
        event: "change"
    },
    data() {
        return {
            innerValue: this.value
        };
    },
    watch: {
        value(val) {
            this.innerValue = val;
        }
    },
    methods: {
        langChange() {
            this.$emit("change", this.innerValue);
        }
    }
};
</script>

<style scoped>
.select-wrapper {
    width: 100%;
}
</style>
